/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_safeGet.js
 ** module id = 407
 ** module chunks = 0
 **/